import { IonText } from '@ionic/react';
import { EditableMissionState } from '../model/EditableMissionState.ts';
import { AuthorizableLAANCAdvisoryProperties } from '@autopylot-internal/tiles-client';
import { IOperator } from '../../profile/IOperator.ts';
import { AuthorizationNotRealWarning } from './AuthorizationNotRealWarning.tsx';
import { DevSettings } from '../../support/DevSettings.ts';
import { WrapWithCardOnLargerScreen } from '../../components/card/WrapWithCardOnLargerScreen.tsx';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { LAANCAuthorizationTextProvider } from '../laanc-authorization/LAANCAuthorizationTextProvider.ts';
import { ICoordinate } from '../../support/model/ICoordinate.ts';

const Authorization = ({ authorization, location, operator, altitude }: { authorization: AuthorizableLAANCAdvisoryProperties, location: ICoordinate, operator: IOperator, altitude: number }) => {
    const provider = useInstance(LAANCAuthorizationTextProvider);

    const html = provider.getAuthorizationAsHTML({ authorization, location, altitude, operator });

    return (
        <p>
            <small dangerouslySetInnerHTML={{ __html: html }} />
        </p>
    );
};

export const AuthorizationDetails: React.FC<{ authorizations: AuthorizableLAANCAdvisoryProperties[], operator: IOperator, mission: EditableMissionState, devSettings: DevSettings }> = ({ authorizations, operator, mission, devSettings }) => {

    return (
        <WrapWithCardOnLargerScreen>
            <div style={{ padding: '10px 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: -20 }}>
                    <h5>LAANC Authorization Details</h5>
                </div>

                {!mission.state.isReal && !devSettings.disableNotRealWarnings &&
                    <AuthorizationNotRealWarning />
                }

                <IonText>
                    {authorizations.map(auth => {
                        return (
                            <Authorization key={auth.operationID} authorization={auth} location={mission.getLocation()} operator={operator} altitude={mission.getMaxAltitude()} />
                        );
                    })}
                    {devSettings.showLAANCAuthDebug && (
                        <>
                            <hr />
                            <h6>Debug JSON:</h6>
                            <small><pre style={{ paddingBottom: 20 }}>
                                {JSON.stringify(authorizations, null, 2)}
                            </pre></small>
                        </>
                    )}
                </IonText>
            </div>
        </WrapWithCardOnLargerScreen>
    );
};
